<template>
  <v-carousel v-model="model">
    <v-carousel-item v-for="(image, i) in images" :key="i">
      <v-sheet height="100%" tile>
        <v-row class="fill-height" align="center" justify="center">
          <v-img :src="image" contain width="100%" height="100%"></v-img>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data: () => ({
    model: 0,
    images: [
      "https://www.instalacioneseficientes.es/wp-content/uploads/2017/06/24-7-365.jpg",
      "https://via.placeholder.com/800x400?text=Slide+2",
      "https://via.placeholder.com/800x400?text=Slide+3",
      "https://via.placeholder.com/800x400?text=Slide+4",
      "https://via.placeholder.com/800x400?text=Slide+5",
    ],
  }),
};
</script>
